import React, { useState, useEffect } from "react";
import styles from "./brand-performance-infinite-table.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import InfiniteDataTable from "../../../../components/infinite-data-table/infinite-data-table";
import {
  fetchMoreBrandPerformanceTable,
  fetchBrandPerformanceTable,
  addSelectedSearchTermGraph,
  removeSelectedSearchTermGraph,
} from "../../actions";

import {
  updateCurrentViewConfigQuery,
  setCurrentViewIsUpdated,
} from "../../../insights/insights-data-controls/actions";

import MbBasicFilters from "../../../../mb_components/mb-basic-filters/mb-basic-filters";
import {
  BRAND_PERFORMANCE_VIEW_TYPE_DATA,
  BRAND_PRODUCT_ATTRIBUTE_MBNAME,
} from "../../constants";
import BrandPerformanceTable from "./brand-performance-table";
import InsightsTemplateLandingPage from "../../../../mb_components/mb-insights-template-landing-page/insights-template-landing-page";
import { getFilterByMbName } from "../../../market-share/utils";

function BrandPerformanceInfiniteTable(props) {
  const {
    insightsFiltersCollection,
    tableData,
    selectedDateRange,
    selectedPreviousDateRange,
    currentViewConfigQuery,
    viewDefinitions,
    loading,
    hasMore,
    loadingMore,
    selectedSearchTermsGraphs,
    currency,
  } = props;

  const [
    updatedCurrentViewConfigQuery,
    setUpdatedCurrentViewConfigQuery,
  ] = useState();

  const requestedParams = {
    ...currentViewConfigQuery,
    startDate: selectedDateRange?.startDate,
    endDate: selectedDateRange?.endDate,
    previousStartDate: selectedPreviousDateRange?.previousStartDate,
    previousEndDate: selectedPreviousDateRange?.previousEndDate,
  };

  const brandFilter = getFilterByMbName(
    insightsFiltersCollection,
    BRAND_PRODUCT_ATTRIBUTE_MBNAME
  );

  const handleFilterChange = () => {
    if (brandFilter && shouldFetchData(requestedParams)) {
      setUpdatedCurrentViewConfigQuery(requestedParams);
      props.fetchBrandPerformanceTable(requestedParams);
    }
  };

  const shouldFetchData = (newUpdatedCurrentViewConfigQuery) => {
    return (
      JSON.stringify(newUpdatedCurrentViewConfigQuery) !==
      JSON.stringify(updatedCurrentViewConfigQuery)
    );
  };

  const updateFilters = (filters) => {
    props.updateCurrentViewConfigQuery({
      productAttributes: filters,
    });
    props.setCurrentViewIsUpdated();
  };

  const fetchMoreData = () => {
    props.fetchMoreBrandPerformanceTable(requestedParams);
  };

  useEffect(() => {
    handleFilterChange();
  }, [requestedParams, insightsFiltersCollection, selectedDateRange]);

  const table = (
    <BrandPerformanceTable
      data={tableData}
      addSelectedSearchTermGraph={props.addSelectedSearchTermGraph}
      removeSelectedSearchTermGraph={props.removeSelectedSearchTermGraph}
      selectedSearchTermsGraphs={selectedSearchTermsGraphs}
      currency={currency}
    />
  );

  const NoDataComponent = () => {
    return brandFilter ? (
      <div className={styles.noData}>
        <div>No data for selected filters</div>
      </div>
    ) : (
      <InsightsTemplateLandingPage
        displayText={"Select a brand to get insights"}
      />
    );
  };

  return (
    <div className={styles.tableWrapper}>
      <div className={styles.controlsWrapper}>
        <MbBasicFilters
          filterDefinitions={viewDefinitions?.filterDefinitions}
          insightsFiltersCollection={insightsFiltersCollection}
          updateFilters={updateFilters}
          viewTypeId={BRAND_PERFORMANCE_VIEW_TYPE_DATA.id}
        />
      </div>
      
      <InfiniteDataTable
        table={table}
        noDataComponent={<NoDataComponent />}
        dataLength={tableData?.length ?? 0}
        hasMore={hasMore}
        fetchMoreData={fetchMoreData}
        loading={loading}
        loadingMore={loadingMore}
      />
    </div>
  );
}

export const mapStateToProps = (state) => {
  return {
    loading: state.brandPerformance?.brandPerformance?.isLoading || state.brandPerformance?.isLoading || false,
    loadingMore: state.brandPerformance?.brandPerformance?.loadingMore || state.brandPerformance?.loadingMore || false,
    tableData: state.brandPerformance?.brandPerformance?.tableData || state.brandPerformance?.tableData || [],
    hasMore: state.brandPerformance?.brandPerformance?.hasMore ?? state.brandPerformance?.hasMore ?? true,
    
    selectedDateRange: state.insights?.mbFilterRow?.selectedDateRange || state.brandPerformance?.mbFilterRow?.selectedDateRange,
    selectedPreviousDateRange: state.insights?.mbFilterRow?.selectedPreviousDateRange || state.brandPerformance?.mbFilterRow?.selectedPreviousDateRange,
    viewDefinitions: state.insights?.insights?.viewDefinitions || state.brandPerformance?.insights?.viewDefinitions,
    filterDefinitions: state.insights?.insights?.viewDefinitions?.filterDefinitions || state.brandPerformance?.insights?.viewDefinitions?.filterDefinitions,
    
    currentViewConfig: state.insights?.insights?.currentViewConfig || state.brandPerformance?.insights?.currentViewConfig,
    currentViewConfigQuery: state.insights?.insights?.currentViewConfig?.query || state.brandPerformance?.insights?.currentViewConfig?.query,
    insightsFiltersCollection: state.insights?.insights?.currentViewConfig?.query?.productAttributes || state.brandPerformance?.insights?.currentViewConfig?.query?.productAttributes,
    offset: state.insights?.insights?.currentViewConfig?.query?.offset || state.brandPerformance?.insights?.currentViewConfig?.query?.offset,
    currency: state.insights?.insights?.currency || state.brandPerformance?.insights?.currency,

    selectedSearchTermsGraphs: state.brandPerformance?.brandPerformance?.selectedSearchTermsGraphs || state.brandPerformance?.selectedSearchTermsGraphs || [],
  };
};

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchMoreBrandPerformanceTable,
      fetchBrandPerformanceTable,
      updateCurrentViewConfigQuery,
      setCurrentViewIsUpdated,
      removeSelectedSearchTermGraph,
      addSelectedSearchTermGraph,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BrandPerformanceInfiniteTable);
